import {Widget} from "../Common";
import {Alert, Button, LinearProgress} from "@mui/material";
import React from "react";
import TabularTextView from "./Common/tabular-text-view";
import {BreederService} from "../../services/breeder-service";
import {useQuery} from "@tanstack/react-query";
import RouteService from "../../services/route-service";
import {useNav} from "../Common/hooks/use-nav";
import {useBreederInfo} from "../../hooks/use-breeders";
import {TbcProgramStatus} from "../../api/generated/herd-breeder";
import {Pets} from "@mui/icons-material";

type OwnerWidgetProps = { ownerId: string; panonId: string; };

const tbcProgram = (status: TbcProgramStatus) => {
    switch (status) {
        case "PARTICIPATING":
            return 'Nimmt teil';
        case "NOT_PARTICIPATING":
            return 'Nimmt nicht teil';
        default:
            return undefined;
    }
};

const OwnerWidgetContent = ({ownerId, panonId}: OwnerWidgetProps) => {
    const {data: ownerDetails, isLoading, isError} = useQuery({
        queryKey: ['breeder', 'details', {id: ownerId}],
        queryFn: () => BreederService.getDetails(ownerId),
    });

    if (isLoading) {
        return (
            <LinearProgress/>
        );
    }

    if (isError || !ownerDetails) {
        return (
            <Alert severity="error">Fehler beim Laden der Besitzerdaten.</Alert>
        );
    }

    const displayPairs = new Map([
        ownerDetails.farmName
            ? ['Hofname', ownerDetails.farmName]
            : ['Benutzername', ownerDetails.username],
        ['Besitzer', ownerDetails.owners?.join(', ')],
        ['Herdkürzel', ownerDetails.herdCode],
        ['TBC-Programm', tbcProgram(ownerDetails.tbcProgram)],
    ].filter((entry): entry is [string, string] => entry[1] !== undefined));

    return (
        <TabularTextView displayPairs={displayPairs}/>
    );
};

export const OwnerWidget = ({ownerId, panonId}: OwnerWidgetProps) => {
    const {data: breeder} = useBreederInfo();
    const nav = useNav();

    const showHerdAnimal = () => nav.push(RouteService.ANIMAL_DETAILS, {panonId});

    return (
        <Widget displayName={
            <>
                Besitzer
                {ownerId === breeder.id
                    ? <Button onClick={showHerdAnimal} startIcon={<Pets/>}>Tier in Herde anzeigen</Button>
                    : null}
            </>
        }>
            <OwnerWidgetContent ownerId={ownerId} panonId={panonId}/>
        </Widget>
    );
};